module.exports = __webpack_public_path__ + "static/merino-shoe-199486233532071d4499a3a75af9a3f0.png";